import { DimensionTabs } from '@features/campaigns/components/RealTimeOptimization/DimensionTabs';
import { DimensionTabsProps } from '@features/campaigns/components/RealTimeOptimization/DimensionTabs/DimensionTabs';
import { Divider, Stack } from '@mui/material';

export type DimensionFilterProps = DimensionTabsProps;

export const DimensionFilter = (props: DimensionFilterProps) => {
  return (
    <Stack direction="column">
      <DimensionTabs {...props} />
      <Divider sx={{ width: '100%' }} />
    </Stack>
  );
};
